import { Component, OnInit, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { HomeService } from '../../service/home/home.service';
import { TempResponseDto } from './dto/temp-response.dto';
import { HttpClient } from "@angular/common/http";
import { DESCIPTION_BASE, TITLE } from "../../constant/app-constant";
import { CanonicalService } from "../../service/canonical/canonical.service";
import { MetaTagsService } from '../../service/meta-tag/meta-tags.service';
import { MatDialog } from '@angular/material/dialog';
import { PopUpComponent } from '../pop-up/pop-up.component';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { FRONT_URL } from "../../constant/app-constant";
export interface TableData {
  country: string;
  price: number;
  img: string
}


const ELEMENT_DATA: TableData[] = [
  { country: 'USA', price: 315.93, img: "USA" },
  { country: 'UK', price: 412.92, img: "UK" },
  { country: 'EUROPE', price: 343.15, img: "Europe" },
  { country: 'SWITZERLAND', price: 337.95, img: "Switzerland" },
  { country: 'CANADA', price: 251.02, img: "canada" },
  { country: 'AUSTRALIA', price: 236.29, img: "Australia" },
  { country: 'SINGAPORE', price: 231.81, img: "Singapore" },


];

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

declare var adsbygoogle: any[];

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {


  displayedColumns: string[] = ['COUNTRY', 'PRICE'];
  dataSource = ELEMENT_DATA;
  value = 0
  base_url = FRONT_URL
  constructor(private homeService: HomeService, private router: Router, private meta: Meta,
    private canonicalService: CanonicalService, @Inject(PLATFORM_ID) private platformId: Object,
    private metaService: MetaTagsService, public dialog: MatDialog,
    private sanitizer: DomSanitizer, @Inject(DOCUMENT) private document: Document) {

    this.getStickyNews()
    // this.getCovidNews()
    this.getExchangeRate()
    this.getWeather()


  }

  latestPost = new Array();
  sportsPosts = new Array();
  businessPosts = new Array();
  worldPosts = new Array();
  stickyPosts = new Array();
  localPosts = new Array();
  featuredPosts = new Array();
  covidDetails = new Array();
  covidNews: any
  tempToday: number = 30
  imgTemp: string = ''
  temp = new TempResponseDto();
  cloudImg = new Array()
  highTemp = new Array()
  lowTemp = new Array()
  week = new Array()

  browser: any
  // test2 = this.sanitizer.bypassSecurityTrustHtml('<ins class="adsbygoogle" style="display:inline-block;width:728px;height:90px"data-ad-client="ca-pub-5432073672371728" data-ad-slot="1098464258"></ins>')
  ngOnInit() {
    this.browser = isPlatformBrowser(this.platformId);
    this.canonicalService.destroyLinkForCanonicalURL()
    this.canonicalService.setCanonicalURL();
    this.metaService.setOgTags(TITLE, DESCIPTION_BASE, 'https://cdn.newsfirst.lk/assets/TV-BG.jpg', "/home");
    for (let index = 0; index < 10; index++) {
      try {
        (adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        // console.error("error");;
      }

    }

  }

  // ngAfterViewInit() {
  //   if (this.browser) {
  //     for (let index = 0; index < 10; index++) {
  //       try {
  //         (adsbygoogle = window.adsbygoogle || []).push({});
  //       } catch (e) {
  //         console.error("error");
  //       }

  //     }

  //   }
  // }


  getStickyNews() {
    this.homeService.getStickyNews().subscribe((resp: any) => {

      for (const element of resp.stickyPost.postResponseDto) {

        this.stickyPosts.push(element.postResponseDto[0])
      }
      this.latestPost = resp.latestPost
      this.localPosts = resp.localPost
      this.featuredPosts = resp.featuredPost
      this.sportsPosts = resp.sportPost
      this.worldPosts = resp.worldPost
      this.businessPosts = resp.businessPost

    })
  }
  price = new Array()
  getExchangeRate() {
    // this.homeService.getExchangeRate().subscribe((resp: any) => {
    //   this.dataSource = resp;
    // })
  }

  getWeather() {
    this.homeService.getWeather().subscribe((resp: any) => {

      for (const i of resp.weatherdata.weather[0].forecast) {

        this.week.push(i.$.shortday)
        this.highTemp.push(i.$.high)
        this.lowTemp.push(i.$.low)

        if (i.$.skytextday == "Mostly Cloudy") {
          this.cloudImg.push("https://ssl.gstatic.com/onebox/weather/64/partly_cloudy.png")
        } else if (i.$.skytextday == "Partly Sunny") {
          this.cloudImg.push("https://ssl.gstatic.com/onebox/weather/64/partly_cloudy.png")
        } else if (i.$.skytextday == "Rain Showers") {
          this.cloudImg.push("https://ssl.gstatic.com/onebox/weather/48/thunderstorms.png")
        } else if (i.$.skytextday == "Rain") {
          this.cloudImg.push("https://ssl.gstatic.com/onebox/weather/48/thunderstorms.png")
        } else if (i.$.skytextday == "Sunny") {
          this.cloudImg.push("https://ssl.gstatic.com/onebox/weather/64/sunny.png")
        } else {
          this.cloudImg.push("https://ssl.gstatic.com/onebox/weather/64/partly_cloudy.png")
        }
        // this.cloudImg.push()

      }

      this.temp.todaytemp = resp.weatherdata.weather[0].current[0].$.temperature
      this.temp.todayWind = resp.weatherdata.weather[0].current[0].$.windspeed
      this.temp.todayHum = resp.weatherdata.weather[0].current[0].$.humidity
      this.temp.todayPrecip = resp.weatherdata.weather[0].current[0].$.feelslike
      const x = resp.weatherdata.weather[0].current[0].$.skytext

      switch (x) {
        case "Partly Sunny":
          this.temp.todayImg = "https://ssl.gstatic.com/onebox/weather/64/partly_cloudy.png"
          break;
        case "Rain Showers":
          this.temp.todayImg = "https://ssl.gstatic.com/onebox/weather/48/rain_s_cloudy.png"
          break;
        case "Rain":
          this.temp.todayImg = "https://ssl.gstatic.com/onebox/weather/48/rain_s_cloudy.png"
          break;
        case "Sunny":
          this.temp.todayImg = "https://ssl.gstatic.com/onebox/weather/64/sunny.png"
          break;
        case "Light Rain":
          this.temp.todayImg = "https://ssl.gstatic.com/onebox/weather/48/thunderstorms.png"
          break;
        default:
          this.temp.todayImg = "https://ssl.gstatic.com/onebox/weather/48/partly_cloudy.png"
          break;
      }
    })
  }
  ids = new Array()
  loadAllPost() {

    for (const iterator of this.stickyPosts) {
      this.ids.push(iterator.id)
    }
    this.homeService.getAllNews(this.ids).subscribe((resp: any) => {
      // this.stickyPosts = resp.stickyNewsdto
      this.latestPost = resp.postResponseDto


    })

  }

  // getCovidNews() {
  //   this.homeService.getCovidNews().subscribe((resp: any) => {


  //     this.covidNews = resp.data

  //   })
  //   this.homeService.getCoivdDetails().subscribe((resp: any) => {
  //     //
  //     this.covidDetails = resp.postResponseDto

  //   })
  // }

  // getLocalNews() {
  //   for (const iterator of this.latestPost) {
  //     this.ids.push(iterator.id)
  //   }

  //   this.homeService.getPostByCategory(2, 10, this.ids).subscribe((resp: any) => {

  //     for (const iterator of resp.postResponseDto) {
  //       this.localPosts.push(iterator)

  //     }
  //   })
  // }

  // getFeaturedNews() {

  //   this.homeService.getPostByCategory(54387, 5, this.ids).subscribe((resp: any) => {

  //     this.featuredPosts = resp.postResponseDto
  //   })
  // }

  // getSportsPost() {
  //   for (const iterator of this.localPosts) {
  //     this.ids.push(iterator.id)
  //   }
  //   this.homeService.getPostByCategory(4, 5, this.ids).subscribe((resp: any) => {
  //     this.sportsPosts = resp.postResponseDto
  //   })
  // }

  // getBusinessPost() {
  //   this.homeService.getPostByCategory(5, 5, this.ids).subscribe((resp: any) => {

  //     this.businessPosts = resp.postResponseDto
  //   })
  // }

  // getWorldPost() {
  //   this.homeService.getPostByCategory(3, 5, this.ids).subscribe((resp: any) => {

  //     this.worldPosts = resp.postResponseDto
  //   })
  // }

  readmore(type: string) {
    this.router.navigate([`/${type}`]);
  }

  replaceString(str: string) {
    // console.log(str);
    // console.log(decodeURI(str));
    str = str.replace('&quot;', '"');
    str = str.replace('&rsquo;', "'")
    return str.replace(/(<([^>]+)>)/ig, '');
  }

  scrollRight() {
    //   if (this.document.getElementById('container_scroll')!.offsetWidth > this.window.width) {
    //     console.log("Width ============");

    // }
    this.document.getElementById('container_scroll')!.scrollLeft += 100;
  }
  scrollLeft() {
    this.document.getElementById('container_scroll')!.scrollLeft -= 100;
  }

  scrollRightTv() {
    this.document.getElementById('container_scroll_tv')!.scrollLeft += 100;
  }
  scrollLeftTv() {
    this.document.getElementById('container_scroll_tv')!.scrollLeft -= 100;
  }

}
